// 请求失败由 API 监控承接；客户端编程异常和主动取消不使用该标记。
export const API_REQUEST_ERROR_NAME = 'ApiRequestError';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function isApiRequestError(error: unknown): boolean {
  try {
    return isRecord(error) && error.name === API_REQUEST_ERROR_NAME;
  } catch {
    return false;
  }
}

export function getApiRequestHttpStatus(error: unknown): number | undefined {
  if (!isApiRequestError(error) || !isRecord(error)) return undefined;
  const { response } = error;
  if (!isRecord(response)) return undefined;
  return typeof response.status === 'number' ? response.status : undefined;
}
